import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/a11y'
import domReady from '@src/js/utils/domReady.js'

function slideshowSwiper() {
  const swiperEl = document.querySelector('.content-block--slideshow__swiper')
  if (!swiperEl) return

  new Swiper(swiperEl, {
    modules: [Navigation, A11y],
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    speed: 750,
    loop: true,
    a11y: {
      enabled: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    }
  })
}

domReady(slideshowSwiper)
